var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#FFA800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03241 5.26721C6.06858 5.2812 6.08904 5.3013 6.1011 5.33456C6.15402 5.4817 6.0266 5.78788 5.95657 5.91314L6.21542 6.05842C6.24415 6.00721 6.49347 5.54868 6.38049 5.23446C6.33941 5.11992 6.25605 5.0356 6.1395 4.9905C6.10318 4.97636 6.08272 4.95641 6.07066 4.923C6.01775 4.77593 6.14531 4.46968 6.21534 4.3445L5.95649 4.19922C5.92777 4.25042 5.6783 4.7088 5.7912 5.02317C5.83235 5.13779 5.91578 5.22233 6.03241 5.26721Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.859 5.26729C6.89525 5.28128 6.91571 5.30137 6.9277 5.33464C6.98076 5.48178 6.85327 5.78796 6.78324 5.91322L7.04194 6.05849C7.07081 6.00729 7.31999 5.54876 7.20716 5.23454C7.166 5.12 7.08265 5.03568 6.96617 4.99057C6.92978 4.97643 6.90931 4.95649 6.89733 4.92307C6.84427 4.77601 6.9719 4.46975 7.04194 4.34457L6.78324 4.19922C6.75436 4.25042 6.50504 4.7088 6.61787 5.02317C6.65917 5.13786 6.74253 5.22241 6.859 5.26729Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68466 5.26736C7.72091 5.2815 7.74152 5.30145 7.75336 5.33471C7.80642 5.48185 7.67893 5.78803 7.60883 5.91329L7.86767 6.05857C7.89633 6.00736 8.14587 5.54898 8.03282 5.23461C7.99166 5.12007 7.90824 5.0356 7.79176 4.9905C7.75552 4.97651 7.7349 4.95641 7.72307 4.92315C7.67015 4.77608 7.79757 4.46983 7.86767 4.3445L7.60875 4.19922C7.58002 4.25035 7.3307 4.70895 7.44375 5.02325C7.48483 5.13794 7.56819 5.22248 7.68466 5.26736Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86481 9.62149H7.92012C8.35893 9.62149 8.72205 9.45046 8.79565 9.03398V6.44922H4.97455V8.87955C4.97455 9.3712 5.37317 9.62149 5.86481 9.62149Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79951 7.81631C9.79951 7.27956 9.42389 6.82081 8.89473 6.63281V6.95366C9.25532 7.11791 9.50278 7.44188 9.50278 7.81639C9.50278 8.19096 9.25532 8.51486 8.89473 8.67897V9.0007C9.42389 8.81286 9.79951 8.35306 9.79951 7.81631Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90944 10.0375C4.99622 10.082 5.14656 10.1219 5.3423 10.1551H8.48309C8.6789 10.1219 8.82909 10.082 8.91572 10.0375C9.31873 9.96594 9.62536 9.87231 9.62536 9.76953H4.19981C4.19981 9.87231 4.50644 9.96594 4.90944 10.0375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreak);
export default __webpack_public_path__ + "static/media/break.e2e35f9c5ba53665e3105952a975a9bb.svg";
export { ForwardRef as ReactComponent };